var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product", class: { "no-padding": _vm.product.noPadding } },
    [
      _vm.product.badge === "blank"
        ? _c("div", { staticClass: "add-badge blank" }, [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.product.badgeText) } }),
          ])
        : _vm.product.showBadge && _vm.product.badge
        ? _c("div", {
            staticClass: "add-badge",
            class:
              _vm.product.badge !== "placeholder" ? _vm.product.badge : null,
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "product-header",
          class: { "left-align": _vm.product.headerLeftAlign },
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.product.title))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.product.subtitle))]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-body" },
        [
          _vm.product.originalPrice
            ? [
                _c("div", { staticClass: "break-line" }),
                _vm._v(" "),
                _c("p", { staticClass: "price original" }, [
                  _vm._v(_vm._s(_vm.product.originalPrice)),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "price discount" },
            [
              _vm.product.discountPriceInValueSpan
                ? _c("span", { staticClass: "value" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.product.discountPrice) +
                        "\n            "
                    ),
                  ])
                : [_vm._v(_vm._s(_vm.product.discountPrice))],
            ],
            2
          ),
          _vm._v(" "),
          _vm.product.bonusDesc || _vm.product.bonusDescHidden
            ? _c(
                "p",
                {
                  staticClass: "price-desc new",
                  class: { hide: _vm.product.bonusDescHidden },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.product.bonusDesc) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.product.priceDesc
            ? _c("p", { staticClass: "price-desc" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.product.priceDesc) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.product.showSubDesc || _vm.product.subDesc
            ? _c(
                "p",
                {
                  staticClass: "price-desc sub",
                  class: { color: _vm.product.subDescColored },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.product.subDesc) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("purchase", _vm.product.link)
                },
              },
            },
            [_vm._v("立即购买")]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }